import {
  Box,
  Container,
  Grid,
  Paper,
  Typography
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const industries = [
  "Transportne kompanije",
  "Servisne službe",
  "Kurirske službe",
  "Prodajni timovi",
  "Mala i srednja preduzeća",
  "Kompanije sa voznim parkom",
];

export default function IndustriesSection() {
  return (
    <Box sx={{ 
        py: 8, 
        bgcolor: "#0d2a4a",  
        backgroundImage: "linear-gradient(rgba(255,255,255,0.03), rgba(255,255,255,0.03))", }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={8}>
          <Typography
            variant="overline"
            color="success.main"
            sx={{ letterSpacing: 2 }}
          >
            ZA KOGA JE TRACKFLEET DMS?
          </Typography>

          <Typography
            variant="h3"
            color="white"
            fontWeight={700}
            mt={2}
            mb={3}
          >
            Prilagođen kompanijama koje upravljaju
            vozilima i terenskim aktivnostima
          </Typography>

          <Typography
            color="grey.400"
            sx={{
              maxWidth: 700,
              mx: "auto",
              lineHeight: 1.8,
              fontSize: "1.05rem",
            }}
          >
            Bez obzira da li upravljate manjim ili većim voznim
            parkom, TrackFleet DMS vam omogućava bolju organizaciju
            i potpunu kontrolu nad svakodnevnim poslovanjem.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {industries.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 4,
                  bgcolor: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  transition: ".2s",
                  "&:hover": {
                    borderColor: "#5abe8a",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CheckCircleOutlineIcon color="success" />
                <Typography color="white">
                  {item}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}